import * as types from './types';

export const getSettingsRequest = (payload) => ({
  type: types.SETTINGS_GET_REQUEST,
  payload,
});

export const settingsUpdateRequest = (payload) => ({
  type: types.SETTINGS_UPDATE_REQUEST,
  payload,
});

export const resetSettingErrors = () => ({
  type: types.SETTINGS_UPDATE_FAILURE,
  payload: null,
});

export const setHoursErrors = (payload) => ({
  type: types.SETTINGS_SET_HOURS_ERRORS,
  payload,
});

export const changeDeliveryData = (payload) => ({
  type: types.SETTINGS_CHANGE_DELIVERY_DATA,
  payload,
});
